import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { X } from 'lucide-react';
import React from 'react';

export default function AdSavedSuccessDialog({ open, onClose }) {
    const handleClose = () => {
        if (onClose) onClose();
    };

    return (
        <Dialog
            open={Boolean(open)}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
            BackdropProps={{
                sx: {
                    backdropFilter: 'blur(6px)',
                    backgroundColor: 'rgba(0,0,0,0.35)',
                },
            }}
            PaperProps={{
                sx: {
                    borderRadius: 4,
                    bgcolor: 'white',
                    boxShadow: 24,
                    overflow: 'hidden',
                },
            }}
        >
            <Box sx={{ position: 'relative', px: 3, pt: 2 }}>
                <IconButton
                    aria-label="Close"
                    onClick={handleClose}
                    size="small"
                    sx={{ position: 'absolute', top: 12, right: 12 }}
                >
                    <X size={18} />
                </IconButton>

                <DialogContent sx={{ px: 0, pt: 6, pb: 4, minHeight: 220 }}>
                    <Typography
                        variant="h3"
                        sx={{
                            fontWeight: 70,
                            color: 'black',
                            textAlign: 'center',
                        }}
                    >
                        Anuncio Guardado
                    </Typography>
                </DialogContent>

                <DialogActions sx={{ px: 0, pb: 2, justifyContent: 'flex-end' }}>
                    <Button
                        variant="contained"
                        onClick={handleClose}
                        sx={{
                            textTransform: 'none',
                            borderRadius: 999,
                            px: 3,
                            bgcolor: 'var(--color-green-primary)',
                            '&:hover': {
                                bgcolor: 'var(--color-green-primary)',
                            },
                        }}
                    >
                        Ok
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
}
